/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import {
    ClockCircleOutlined,
    CloseOutlined,
    ExclamationCircleOutlined,
    MoreOutlined,
    EyeOutlined,
} from '@ant-design/icons';
import {
    Button,
    Descriptions,
    Drawer,
    Dropdown,
    Menu,
    Select,
    Tooltip,
} from 'antd';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DataFlowService from '../../../../services/DataFlow.service';
import { useEffect, useState } from 'react';
import moment from 'moment';

import UserService from '../../../../services/UserService';
import ModalDelete from '../../../../components/Shared/modal/delete';
import useNotify from '../../../../context/Notification/useNotify';
import ModalFail from './../../../../components/Shared/modal/fail';
import { useNavigate } from 'react-router-dom';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import ModalReviewed from './components/ModalReviewed';
import ModalRevise from './components/ModalRevise';
import ModalDataFlow from '../ModalDataFlow';
import { STATUS_ID as STATUS } from '../../STATUS_ID';
import { ROUTER } from '../../../../constants/router';
import GlobalService from '../../../../services/Global.service';
import DataBreachService from '../../../../services/DataBreach.service';

import { ConvertDate } from './components/utils';
import ModalRequestRevise from './components/ModalRequestRevise';
import History from './History';
import usePermission from '../../../../hooks/usePermission';
import ModalChangeStatus from './components/ModalChangeStatus';

const { Option } = Select;

export default function Detail({
    detailDataflow,
    dataFlowInfo,
    getInventoryDataFlowInfo,
}) {
    const notify = useNotify();
    const { t, i18n } = useTranslation();
    const { businessProcessId } = useParams();

    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const superAdmin = ['super admin'].includes(role);
    const userRole = ['user'].includes(role);
    const adminRole = ['admin'].includes(role);

    const id = UserService.getUi();

    let navigate = useNavigate();
    // state
    const [statusList, setStatusList] = useState([]);
    const [visible, setVisible] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openFail, setOpenFail] = useState(false);
    const [msg, setMsg] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openConfirm2, setOpenConfirm2] = useState(false);
    const [openConfirm3, setOpenConfirm3] = useState(false);
    const [openRequest, setOpenRequest] = useState(false);
    const [openConfirmRevise, setOpenConfirmRevise] = useState(false);
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [reason, setReason] = useState('');
    const [currentUser, setCurrentUser] = useState();

    const [oraganize, setOraganize] = useState([]);

    const { isAuditor } = usePermission();
    const [userOptions, setUserOptions] = useState([]);

    useEffect(async () => {
        const getOrganizeAdmin = async () => {
            try {
                const { data } = await GlobalService.getOrganizeAdmin();
                if (data?.resultData) {
                    setOraganize(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        const getUserOptions = async () => {
            try {
                const { data } = await DataBreachService.getUserList();
                if (data?.resultData) {
                    setUserOptions(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };

        const getUserId = async () => {
            try {
                const user = UserService.getUi();
                if (user) {
                    setCurrentUser(user);
                }
            } catch (err) {
                console.log(err);
            }
        };

        getOrganizeAdmin();
        getUserOptions();
        await getUserId();
    }, []);

    const menu = (
        <Menu
            items={[
                {
                    label:
                        !admin && dataFlowInfo?.statusId === STATUS.REVISE
                            ? t('dataFlow.EditPurpose')
                            : t('common.Edit'),
                    onClick: () => {
                        setOpenModal(true);
                    },
                },
                {
                    label:
                        !admin && dataFlowInfo?.statusId === STATUS.REVISE
                            ? t('dataFlow.DeletePurpose')
                            : t('common.Delete'),
                    onClick: () => {
                        setOpenDelete(true);
                    },
                },
            ]}
        />
    );

    const menu_wait = (
        <Menu
            items={[
                {
                    label: t('common.Edit'),
                    onClick: () => {
                        setOpenModal(true);
                    },
                },
            ]}
        />
    );

    const switchMenu =
        admin && dataFlowInfo?.statusId === STATUS.WAITING_FOR_REVIEW
            ? menu_wait
            : menu;

    const deleteDataFlow = async (id) => {
        await DataFlowService.deleteDataFlow(id)
            .then((res) => {
                if (res?.data?.errorData) {
                    if (res?.data?.errorData?.code === 400) {
                        setOpenFail(true);
                        setMsg(res?.data?.errorData?.msg);
                    }
                } else {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully deleted data'),
                    });
                    setTimeout(() => {
                        navigate(ROUTER.DS_INVENTORY.DATAFLOW);
                    }, 2500);
                }
            })
            .catch((err) => {
                setOpenFail(true);
                setMsg(t('common.FailedDeleteData'));
            });
    };

    const getStatus = async () => {
        try {
            const { data } = await DataFlowService.getStatus({
                type: 'data-flow',
            });
            let status = [];
            if (data?.resultData) {
                if (!admin) {
                    // role user
                    // draft
                    if (dataFlowInfo?.statusId === STATUS.DRAFT) {
                        const _case = [STATUS.DRAFT, STATUS.WAITING_FOR_REVIEW];
                        const _status = data?.resultData.filter((result) =>
                            _case.includes(result.statusId)
                        );
                        status.push(..._status);
                    } else if (dataFlowInfo?.statusId === STATUS.REVISE) {
                        // Revive
                        const _case = [
                            STATUS.REVISE,
                            STATUS.WAITING_FOR_REVIEW,
                        ];
                        const _status = data?.resultData.filter((result) =>
                            _case.includes(result.statusId)
                        );

                        status.push(..._status);
                    } else {
                        status = data?.resultData;
                    }
                } else {
                    // role admin
                    // รอตรวจสอบ
                    if (
                        dataFlowInfo?.statusId === STATUS.WAITING_FOR_REVIEW ||
                        dataFlowInfo?.statusId === STATUS.REVIEWED
                    ) {
                        const _case = [
                            STATUS.WAITING_FOR_REVIEW,
                            STATUS.REVIEWED,
                            STATUS.REVISE,
                        ];
                        const _status = data?.resultData.filter((result) =>
                            _case.includes(result.statusId)
                        );

                        status.push(..._status);
                    } else if (dataFlowInfo?.statusId === STATUS.DRAFT) {
                        const _case = [STATUS.DRAFT, STATUS.WAITING_FOR_REVIEW];
                        const _status = data?.resultData.filter((result) =>
                            _case.includes(result.statusId)
                        );
                        status.push(..._status);
                    } else if (dataFlowInfo?.statusId === STATUS.REVISE) {
                        // Revise
                        const _case = [
                            STATUS.REVISE,
                            STATUS.WAITING_FOR_REVIEW,
                        ];
                        const _status = data?.resultData.filter((result) =>
                            _case.includes(result.statusId)
                        );

                        status.push(..._status);
                    } else {
                        status = data?.resultData;
                    }
                }
                setStatusList(status);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if (dataFlowInfo) getStatus();
    }, [businessProcessId, dataFlowInfo]);

    const isDisabled = () => {
        if (isAuditor) return true;
        if (!detailDataflow) return true;

        const {
            categoryPersonalData,
            collectData,
            collectDataDestruction,
            referenceDocuments,
        } = detailDataflow;

        return !(
            categoryPersonalData &&
            collectData &&
            collectDataDestruction &&
            referenceDocuments.length > 0
        );
    };

    const isRequestRevise = Number(dataFlowInfo?.isRequestRevise) === 1;

    const checkStatus = () => {
        const statusId = dataFlowInfo?.statusId;
        const reviewById1 = dataFlowInfo?.reviewById;
        const reviewById2 = dataFlowInfo?.reviewById2;
        const reviewDate1 = dataFlowInfo?.reviewDate;
        const reviewDate2 = dataFlowInfo?.reviewDate2;
        const reviewer = dataFlowInfo?.reviewer;
        const disabled = true;
        const enabled = false;
        if (!admin) {
            return [STATUS.WAITING_FOR_REVIEW, STATUS.REVIEWED].includes(
                statusId
            );
        } else {
            if (statusId === STATUS.DRAFT) return enabled;
            if (statusId === STATUS.WAITING_FOR_REVIEW) {
                if (superAdmin) {
                    return enabled;
                } else {
                    if (reviewDate1 && reviewDate2) {
                        if (currentUser === reviewer) {
                            return enabled;
                        } else {
                            return disabled;
                        }
                    }

                    if (currentUser === reviewer && !reviewById2) {
                        return enabled;
                    } else if (
                        currentUser === reviewById2 &&
                        reviewDate1 &&
                        !reviewDate2
                    ) {
                        return enabled;
                    } else if (
                        currentUser === reviewer &&
                        reviewDate1 &&
                        !reviewById2
                    ) {
                        return enabled;
                    } else {
                        return disabled;
                    }
                }
            }
            if (statusId === STATUS.REVIEWED) {
                return isRequestRevise;
            }
            return enabled;
        }
    };

    const checkMore = () => {
        if (isAuditor) return true;
        if (!admin) {
            if (
                dataFlowInfo?.statusId === STATUS.REVIEWED ||
                dataFlowInfo?.statusId === STATUS.WAITING_FOR_REVIEW
            ) {
                return true;
            } else {
                return false;
            }
        } else {
            if (dataFlowInfo?.statusId === STATUS.REVIEWED) {
                return true;
            } else {
                return false;
            }
        }
    };

    const handelOk = async () => {
        let payload = {
            businessProcessId,
            status,
            lastReviewDate: null,
            nextReviewDue: null,
            reason,
        };
        if (openConfirmRevise) {
            payload = {
                businessProcessId,
                status,
                lastReviewDate: null,
                nextReviewDue: null,
                isApproveRequestRevise: true,
                reason,
            };
        }
        setLoading(true);
        try {
            const { data } = await DataFlowService.changeStatusDataFlow(
                payload
            );
            if (data.resultCode === 1) {
                getInventoryDataFlowInfo();
                setLoading(false);
                setOpenConfirm(false);
                setOpenConfirmRevise(false);
                navigate(
                    `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view`
                );
                notify({
                    title: t('common.Success'),
                    description: t('Successfully save data'),
                });
            } else {
                setLoading(false);
                setOpenConfirm(false);
                setOpenConfirmRevise(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            setOpenConfirm(false);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
        }
    };

    const handelReviewerOk = async (userId) => {
        let payload = {
            businessProcessId,
            status,
            lastReviewDate: null,
            nextReviewDue: null,
            reason,
            reviewer: userId,
        };

        setLoading(true);
        try {
            const { data } = await DataFlowService.changeStatusDataFlow(
                payload
            );
            if (data.resultCode === 1) {
                getInventoryDataFlowInfo();
                setLoading(false);
                setOpenConfirm(false);
                setOpenConfirmRevise(false);
                navigate(
                    `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view`
                );
                notify({
                    title: t('common.Success'),
                    description: t('Successfully save data'),
                });
            } else {
                setLoading(false);
                setOpenConfirm(false);
                setOpenConfirmRevise(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            setOpenConfirm(false);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
        }
    };

    const onChange = (value) => {
        if (value === STATUS.DRAFT) {
            setOpenConfirm(true);
            setStatus(STATUS.DRAFT);
        }
        if (value === STATUS.REVISE) {
            setOpenConfirm3(true);
            setStatus(STATUS.REVISE);
        }
        if (value === STATUS.WAITING_FOR_REVIEW) {
            setOpenConfirm(true);
            setStatus(STATUS.WAITING_FOR_REVIEW);
        }
        if (value === STATUS.REVIEWED) {
            setOpenConfirm2(true);
            setStatus(STATUS.REVIEWED);
        }
    };

    const reviewBy = dataFlowInfo?.reviewBy;
    const reviewBy2 = dataFlowInfo?.reviewBy2;

    const [callHistory, setCallHistory] = useState(true);

    return (
        <div className="bg-white w-full p-4 pb-8 rounded-xl">
            <div
                className="pb-2 flex justify-between"
                style={{ borderBottom: '3px solid #F4F6FC' }}
            >
                {!checkStatus() ? (
                    <div className="flex items-center">
                        <Dropdown
                            placement="bottomLeft"
                            arrow
                            overlay={switchMenu}
                        >
                            <button
                                hidden={checkMore()}
                                className="w-8 h-8 bg-gray-100 px-2 rounded-lg mx-4 items-center flex"
                            >
                                <MoreOutlined className="rotate-90" />
                            </button>
                        </Dropdown>
                        <Descriptions className="pr-4">
                            <Descriptions.Item
                                className="!pb-0"
                                label={
                                    <span className="text-[17px] font-medium text-purple">
                                        {dataFlowInfo?.businessProcessName ||
                                            '-'}
                                    </span>
                                }
                            >
                                <span className="text-[17px] font-medium text-purple">
                                    {dataFlowInfo?.businessProcessFullName ||
                                        '-'}
                                </span>
                            </Descriptions.Item>
                        </Descriptions>
                    </div>
                ) : (
                    <div className="flex items-center">
                        <Descriptions className="pr-4">
                            <Descriptions.Item
                                className="!pb-0"
                                label={
                                    <span className="text-[17px] font-medium text-purple">
                                        {dataFlowInfo?.businessProcessName ||
                                            '-'}
                                    </span>
                                }
                            >
                                <span className="text-[17px] font-medium text-purple">
                                    {dataFlowInfo?.businessProcessFullName ||
                                        '-'}
                                </span>
                            </Descriptions.Item>
                        </Descriptions>
                    </div>
                )}

                {/* History */}
                <div className="flex space-x-4 items-center">
                    <span className="text-xs text-[#65707A] w-24">
                        {t('Version')}: {dataFlowInfo?.version || '-'}
                    </span>
                    {!admin && dataFlowInfo?.statusId === STATUS.REVIEWED && (
                        <Button
                            disabled={isRequestRevise}
                            onClick={() => setOpenRequest(true)}
                            type="primary"
                        >
                            {t('Request Revise')}
                        </Button>
                    )}
                    {admin &&
                        dataFlowInfo?.statusId === STATUS.REVIEWED &&
                        isRequestRevise && (
                            <Button
                                onClick={() => {
                                    setOpenConfirmRevise(true);
                                    setReason(
                                        `อนุมัติคำขอแก้ไข : ${dataFlowInfo?.reviseReason}`
                                    );
                                    setStatus(STATUS.REVISE);
                                }}
                                type="primary"
                            >
                                {t('Approve')}
                            </Button>
                        )}
                    <button
                        onClick={() => {
                            setCallHistory(true);
                            setVisible(true);
                        }}
                        className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm"
                    >
                        <ClockCircleOutlined />
                    </button>
                    <Drawer
                        width={460}
                        title={
                            <div className="flex justify-between items-center">
                                <span className="text-purple text-[17px]">
                                    {t('History')}
                                </span>
                                <button
                                    type="button"
                                    onClick={(e) => setVisible(false)}
                                    className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm font-semibold"
                                >
                                    <CloseOutlined />
                                </button>
                            </div>
                        }
                        placement="right"
                        onClose={() => setVisible(false)}
                        closable={false}
                        open={visible}
                        className="history"
                    >
                        <History
                            callHistory={callHistory}
                            setCallHistory={setCallHistory}
                            service={DataFlowService.getHistoryDataFlowInfo}
                        />
                    </Drawer>
                </div>
            </div>
            <div className="grid lg:grid-cols-10 gap-4 mt-6">
                <div className="space-y-6 col-span-4">
                    <div className="grid grid-cols-2 items-center">
                        <div className="font-semibold">{t('Department')} :</div>
                        <div>
                            {i18n.language === 'en'
                                ? dataFlowInfo?.departmentNameEn
                                : dataFlowInfo?.departmentNameTh || '-'}
                        </div>
                    </div>
                    <div className="grid grid-cols-2">
                        <div className="font-semibold">
                            {t('dataFlow.Purpose')} :
                        </div>
                        <div>{dataFlowInfo?.purposeName || '-'}</div>
                    </div>
                </div>
                <div className="space-y-6 col-span-4">
                    <div className="flex">
                        <div className="basis-3/12 font-semibold">
                            {t('dataFlow.ReviewBy')} :
                        </div>
                        <div className="basis-9/12 space-y-2">
                            {reviewBy ? (
                                <div className="flex items-center space-x-2">
                                    <span>{reviewBy}</span>
                                    {dataFlowInfo?.reviewDate ? (
                                        <div className="reviewed">
                                            {t('reviewed')}{' '}
                                            {ConvertDate(
                                                dataFlowInfo?.reviewDate
                                            )}
                                        </div>
                                    ) : (
                                        <div className="waitreviewed">
                                            {t('Waiting for Review')}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                '-'
                            )}
                            {reviewBy2 && (
                                <div className="flex items-center space-x-2">
                                    <span>{reviewBy2}</span>
                                    {dataFlowInfo?.reviewDate2 ? (
                                        <div className="reviewed">
                                            {t('reviewed')}{' '}
                                            {ConvertDate(
                                                dataFlowInfo?.reviewDate2
                                            )}
                                        </div>
                                    ) : (
                                        <div className="waitreviewed">
                                            {t('Waiting for Review')}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="flex items-center">
                        <div className="basis-3/12 font-semibold">
                            {t('dataFlow.LastReviewDate')} :
                        </div>
                        <div className="basis-9/12">
                            {dataFlowInfo?.reviewDate2 ||
                            dataFlowInfo?.reviewDate
                                ? moment(
                                      dataFlowInfo?.reviewDate2 ||
                                          dataFlowInfo?.reviewDate
                                  ).format('DD/MM/YYYY HH:mm')
                                : '-'}
                        </div>
                    </div>
                    <div className="flex items-center">
                        <div className="basis-3/12 font-semibold">
                            {t('dataFlow.NextReviewDue')} :
                        </div>
                        <div className="basis-9/12">
                            {dataFlowInfo?.nextReviewDue
                                ? moment(dataFlowInfo?.nextReviewDue).format(
                                      'DD/MM/YYYY HH:mm'
                                  )
                                : '-'}
                        </div>
                    </div>
                </div>
                <div className="space-y-6 col-span-2">
                    <Link
                        to={`${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/preview`}
                        className="text-[#1890FF] font-semibold flex items-center space-x-2 whitespace-nowrap"
                    >
                        <EyeOutlined />
                        <span>{t('See overview information')}</span>
                    </Link>
                    <div className="grid grid-cols-2">
                        <div className="font-semibold">{t('Status')} :</div>
                        <div className="flex space-x-2 items-center">
                            {statusList.length > 0 && (
                                <Select
                                    disabled={isDisabled() || checkStatus()}
                                    value={dataFlowInfo?.statusId}
                                    size="large"
                                    style={{ width: '100%' }}
                                    onChange={onChange}
                                >
                                    {statusList?.map((status) => (
                                        <Option
                                            key={status?.statusId}
                                            value={status?.statusId}
                                        >
                                            {i18n.language === 'en'
                                                ? status?.nameEn
                                                : status?.nameTh}
                                        </Option>
                                    ))}
                                </Select>
                            )}

                            {isDisabled() && (
                                <Tooltip
                                    placement="bottomRight"
                                    title={t(
                                        'dataFlow.PleaseSpecifyAllInformation'
                                    )}
                                >
                                    <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                        <ExclamationCircleOutlined />
                                    </a>
                                </Tooltip>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <ModalDataFlow
                mode="editDataFlow"
                departmentList={[]}
                dataFlowInfo={dataFlowInfo}
                getInventoryDataFlowInfo={getInventoryDataFlowInfo}
                open={openModal}
                handelClose={() => {
                    setOpenModal(false);
                }}
            />
            <ModalChangeStatus
                loading={loading}
                open={openConfirm}
                handelClose={() => setOpenConfirm(false)}
                userOptions={userOptions}
                handelReviewerOk={handelReviewerOk}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirmRevise}
                handelOk={handelOk}
                handelClose={() => setOpenConfirmRevise(false)}
            />
            <ModalReviewed
                dataFlowInfo={dataFlowInfo}
                oraganize={oraganize}
                status={status}
                getInventoryDataFlowInfo={getInventoryDataFlowInfo}
                open={openConfirm2}
                handelClose={() => setOpenConfirm2(false)}
            />
            <ModalRevise
                status={status}
                getInventoryDataFlowInfo={getInventoryDataFlowInfo}
                department={
                    i18n.language === 'en'
                        ? dataFlowInfo?.departmentNameEn
                        : dataFlowInfo?.departmentNameTh || '-'
                }
                open={openConfirm3}
                handelClose={() => setOpenConfirm3(false)}
            />
            <ModalRequestRevise
                getInventoryDataFlowInfo={getInventoryDataFlowInfo}
                open={openRequest}
                handelClose={() => setOpenRequest(false)}
            />
            <ModalFail
                text={msg}
                open={openFail}
                handelClose={() => setOpenFail(false)}
            />
            <ModalDelete
                open={openDelete}
                text={t('modalDataFlowDelete', {
                    name: dataFlowInfo?.businessProcessName,
                })}
                handelOk={() => {
                    deleteDataFlow(businessProcessId);
                    setOpenDelete(false);
                }}
                handelClose={() => setOpenDelete(false)}
            />
        </div>
    );
}
